export function trim(string, lower = true) {
  if (string === null || string === undefined) {
    return string
  }

  return (lower ? string.toLowerCase() : string).replace(/[^А-ЯЁA-Z .,'()-]/gi, '')
    .replace(/^[ .,'()-]+/gi, '')
    .replace(/^[ .,'-]+/gi, '')
    .replace(/[(]+/gi, ' (')
    .replace(/[)]+/gi, ') ')
    .replace(/ \(\) /gi, '')
    .replace(/[.]+/gi, '. ')
    .replace(/,+/gi, ', ')
    .replace(/-+/gi, '-')
    .replace(/'+/gi, '\'')
    .replace(/ +/gi, ' ')
}

export function capitalize(string, lower = false) {
  if (string === null || string === undefined) {
    return string
  }

  return (lower ? string.toLowerCase() : string)
    .replace(/(?:^|\s|['.,()-])+\S/g, match => match.toUpperCase())
}

export function cloneObject(object) {
  return JSON.parse(JSON.stringify(object))
}

export function firstElement(collection) {
  if (collection instanceof Array) {
    return collection[0]
  }

  if (collection instanceof Object) {
    const objectKeys = Object.keys(collection)
    if (objectKeys.length === 0) {
      return null
    }

    const firstKey = objectKeys[0]

    return collection[firstKey]
  }

  return null
}

export function filterObject(object, predicate) {
  var result = {}

  for (const key in object) {
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      result[key] = object[key]
    }
  }

  return result
}

export function declOfNum(number, titles) {
  const cases = [2, 0, 1, 1, 1, 2]

  return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
}
